module.exports = __webpack_public_path__ + "img/9.edd7dea1.png";